import Badge from "react-bootstrap/Badge";

export const getStatusBadge = (status) => {
  const statusColors = {
    created: "secondary",
    sent: "primary", 
    delivered: "info",
    completed: "success",
    declined: "danger",
    rejected: "danger",
    voided: "warning",
    expired: "dark"
  };

  return (
    <Badge bg={statusColors[status] || "secondary"} className="text-capitalize">
      {status}
    </Badge>
  );
};